import React from 'react';
import PageShell from '../Components/ui/PageShell';
import EmployeeWorkSummarySection from '../Components/admin/EmployeeWorkSummarySection';

function EmployeeWorkSummaryPage() {
  return (
    <PageShell
      title="Employee Work Summary"
      subtitle="Recruiter and team lead performance by assignments, sourced profiles, and status history."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Employee Work Summary' },
      ]}
    >
      <section className="hr-card">
        <EmployeeWorkSummarySection embedded />
      </section>
    </PageShell>
  );
}

export default EmployeeWorkSummaryPage;
